var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7148 22.9167C19.7148 24.5744 20.3733 26.1641 21.5454 27.3362C22.7175 28.5083 24.3072 29.1667 25.9648 29.1667C27.6224 29.1667 29.2122 28.5083 30.3843 27.3362C31.5564 26.1641 32.2148 24.5744 32.2148 22.9167C32.2148 21.2591 31.5564 19.6694 30.3843 18.4973C29.2122 17.3252 27.6224 16.6667 25.9648 16.6667C24.3072 16.6667 22.7175 17.3252 21.5454 18.4973C20.3733 19.6694 19.7148 21.2591 19.7148 22.9167Z",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5961 44.4291C26.8319 44.7539 25.9881 44.8429 25.1729 44.6848C24.3577 44.5267 23.6084 44.1286 23.0211 43.5416L14.1794 34.702C12.2392 32.7616 10.808 30.3722 10.0131 27.7458C9.21811 25.1194 9.08392 22.3374 9.62242 19.6467C10.1609 16.956 11.3554 14.4399 13.0999 12.3218C14.8444 10.2036 17.0849 8.54897 19.6225 7.50472C22.1601 6.46048 24.9163 6.05894 27.6463 6.33576C30.3764 6.61258 32.9958 7.55919 35.2722 9.09155C37.5485 10.6239 39.4113 12.6946 40.6951 15.1198C41.9789 17.545 42.6441 20.2497 42.6315 22.9937",
    stroke: "#2C2C2C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9671 41.9189C45.8414 41.0449 46.4368 39.9312 46.6781 38.7188C46.9194 37.5064 46.7958 36.2496 46.3228 35.1074C45.8498 33.9653 45.0487 32.9891 44.0209 32.3022C42.993 31.6154 41.7846 31.2488 40.5483 31.2488C39.3121 31.2488 38.1037 31.6154 37.0758 32.3022C36.048 32.9891 35.2469 33.9653 34.7739 35.1074C34.3009 36.2496 34.1773 37.5064 34.4186 38.7188C34.6599 39.9312 35.2553 41.0449 36.1296 41.9189C37.0004 42.7918 38.4733 44.0959 40.5483 45.8334C42.7379 43.9793 44.2129 42.6751 44.9671 41.9189Z",
    stroke: "#2C2C2C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5483 37.5V37.5208",
    stroke: "#2C2C2C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.964844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery03);
export default __webpack_public_path__ + "static/media/delivery-03.feeea04dc184bbdb1b7e007f7ae2d580.svg";
export { ForwardRef as ReactComponent };